import { useEffect, useState } from 'react';

import type { RegistrationFormSchema } from 'components/LoginForm/Register/types';

export const useRegistrationSchema = (id = import.meta.env.VITE_APP_ID) => {
  const [schema, setSchema] = useState<RegistrationFormSchema | null>(null);

  if (id === undefined) {
    throw new Error('App ID is not set');
  }

  useEffect(() => {
    const loadSchema = async () => {
      try {
        const module = (await import(`./schemas/${id}.schema.ts`)) as { default: RegistrationFormSchema };
        setSchema(module.default);
      } catch {
        const module = await import(`./schemas/default.schema.ts`);
        setSchema(module.default);
      }
    };

    void loadSchema();
  }, [id]);

  return { schema, isLoading: schema === null };
};
